import { Component } from '@angular/core';
import { NavController, LoadingController, Events, NavParams} from 'ionic-angular';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from '../../../../../../../UI/src/app/shared/translation/translation-loader.service';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { JobDetailsPage } from '../../../job-search/components/job-details/job-details.component';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { CandidateProfileComponent } from '../../../../modules/candidate-profile/candidate-profile.component';
import { ReviewCandidateProfileComponent } from '../../../../modules/review-candidate-profile/review-candidate-profile.component';
import { JobAssessmentComponent } from '../../../job-search/components/job-assessment/job-assessment.component';
import { AddResumeComponent } from '../add-resume/add-resume.component';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { OTPRequestDTO, AuthRequestDTO } from '../../../../../../../UI/src/app/shared/authentication/otp-request-dto';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';

@Component({
  selector: 'sts-password-reset',
  templateUrl: 'password-reset.component.html'
})
export class PasswordResetComponent {
  private loading;
  public alertData: any;
  public showTemporaryCode = false;
  public resetTranslations: any;
  public oneTimePassword = '';
  public inputPhoneNumber;
  public userEmailId;
  public isEmail: boolean = true;
  public isJobApply;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public navParams: NavParams,
    private authenticationService: AuthenticationService,
    private translationLoader: TranslationLoaderService,
    public loadingCtrl: LoadingController,
    private profileService: ProfileService,
    private jobService: JobService,
    private resumeService : ResumeService,
    private toastService: ToastControllerService,
    private translate: TranslateService,
    private toast508Service: Toast508Service
  ) {
    this.translate.get(['CAREER_SENT_TEMP_CODE', 'CAREER_EMAIL_NOT_REGISTERED', 'CAREER_INVALID_CODE', 'CAREER_MOBILE_NOT_REGISTERED', 'CAREER_FAILED_MESSAGE', 'CAREER_INVALID_USER'])
      .subscribe((obj) => {
        this.resetTranslations = obj;
      });
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });
    this.isJobApply =  navParams.get("isJobApply");
  }

  sendTemporaryCode(resend) {
    this.loading.present();
    const requestDTO = new OTPRequestDTO();
    if (this.isEmail) {
      requestDTO.UserIdentifier = this.userEmailId;
      requestDTO.IsEmail = true;
    }
    else {
      requestDTO.UserIdentifier = this.inputPhoneNumber;
      requestDTO.IsEmail = false;
    }
    requestDTO.OTP = this.oneTimePassword;
    this.authenticationService.sendTemporaryCode(requestDTO).subscribe(
      (response) => {
        if (response === true) {
          this.showTemporaryCode = true;
          this.loading.dismiss();
          if (resend) {
            this.alertData = { message: this.resetTranslations.CAREER_SENT_TEMP_CODE, type: 'success' };
            this.toastService.presentToast(this.alertData);
            this.toast508Service.toFocus();
          }
        } else {
          this.loading.dismiss();
          if (this.isEmail) {
            this.alertData = { message: this.resetTranslations.CAREER_EMAIL_NOT_REGISTERED, type: 'error' };
          } else {
            this.alertData = { message: this.resetTranslations.CAREER_MOBILE_NOT_REGISTERED, type: 'error' };
          }
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        }
      }, (error) => {
        this.loading.dismiss();
        if (this.isEmail) {
          this.alertData = { message: this.resetTranslations.CAREER_EMAIL_NOT_REGISTERED, type: 'error' };
        } else {
          this.alertData = { message: this.resetTranslations.CAREER_MOBILE_NOT_REGISTERED, type: 'error' };
        }
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
      }
    );
  }

  validate() {
    this.loading.present();
    const authRequest = new AuthRequestDTO();
    if (this.isEmail) {
      authRequest.Username = this.userEmailId;
    }
    else {
      authRequest.Username = this.inputPhoneNumber;
    }
    authRequest.OTP = this.oneTimePassword;
    authRequest.Password = this.oneTimePassword;
    authRequest.IsEmail = this.isEmail
    this.authenticationService.passwordReset(authRequest).subscribe(
      (response) => {
        window.localStorage.setItem(Storage.AUTH_TOKEN, JSON.parse(response));
        this.translationLoader.checkCultureChange();
        this.loading.dismiss();
        this.profileService.getProfileData().subscribe((profileResponse) => {
            const jobApplyObject: JobApplyObject = this.jobService.getApplyJobObject();
            if (profileResponse[0].resumeType !== 0) {
              if (jobApplyObject != null && jobApplyObject.JobId != null && this.isJobApply) {
                this.resumeService.getResumeData().subscribe(
                  (resumeDataResponse) => {
                    if (resumeDataResponse.isConfirmed) {
                      this.jobService.getAssessmentIdForRequisition(jobApplyObject.JobId).subscribe(
                        (assessmentResponse) => {
                        if(assessmentResponse === 0) {
                          this.profileService.applyJob(jobApplyObject.JobId).subscribe(
                            (applyJobResponse) => {
                              if (applyJobResponse > 0) {
                                // Job Applied
                                this.jobService.setSuccessAlert(0);
                              } else if (applyJobResponse === -1) {
                                // Job Already Applied
                                this.jobService.setSuccessAlert(1);
                              } else if (applyJobResponse === -50) {
                                // Job Applied Failure
                                this.jobService.setSuccessAlert(2);
                              }
                              this.navCtrl.setRoot(CandidateProfileComponent);
                              this.navCtrl.push(JobDetailsPage);
                              this.events.publish('showSiteMapNodes', true);
                            }, (error) => {

                            });
                          } else {
                            this.navCtrl.push(JobAssessmentComponent, {"assessmentId":assessmentResponse,"jobId": jobApplyObject.JobId, "navigatedFrom": this.navCtrl.getActive().name, "isAssessment":false});
                            this.events.publish('showSiteMapNodes', true);
                          }
                        }, (error) => {
                          this.alertData = { message: this.resetTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
                        });
                      } else {
                        this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false, isJobApply: this.isJobApply, showNavbar: true});
                        this.navCtrl.push(ReviewCandidateProfileComponent);
                        this.events.publish('showSiteMapNodes', true);
                      }
                    }, (error) => {
                      // TODO : Implement alert
                    });
                  } else {
                    this.navCtrl.setRoot(CandidateProfileComponent);
                    this.events.publish('showSiteMapNodes', true);
                  }
                } else {
                  if(this.isJobApply){
                    this.navCtrl.setRoot(CandidateProfileComponent);
                    this.resumeService.setResumeAction({action: 'CREATE_RESUME', isInititalCreation: true, isJobApply: this.isJobApply});
                    this.navCtrl.push(AddResumeComponent);
                  }
                  else {
                    this.navCtrl.setRoot(CandidateProfileComponent);
                  }
                  this.events.publish('showSiteMapNodes', true);
                }
              }, (error) => {
                this.loading.dismiss();
                const alertData = { message: this.resetTranslations.CAREER_INVALID_USER, type: 'error' };
                this.toastService.presentToast(alertData);
                this.toast508Service.toFocus();
              });
            }, (error) => {
              this.loading.dismiss();
              this.alertData = { message: this.resetTranslations.CAREER_INVALID_CODE, type: 'error' };
            });
          }

  getPhoneNumber(userPhoneNumber) {
    this.inputPhoneNumber = userPhoneNumber;
  }

  switchInputFormat(input) {
    this.authenticationService.isEmail = input;
    this.authenticationService.isLoginTypeChanged = true;
    if(input) {
      this.userEmailId = this.userEmailId;
      this.isEmail = input;
    }
    else {
      this.inputPhoneNumber = this.inputPhoneNumber;
      this.isEmail = input;
    }
  }

  onCancel() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/components/password-reset/password-reset.component.ts